<template lang="pug">
  .list-folders.pb-4
    .table-view-header
      h3 Creación de carpetas
      .table-view-header-actions
        b-button(v-b-modal.create-folder-modal size="sm" variant="secondary") + Nuevo
    .view-container
      b-card
        .folder-item(v-for="(folder, index) in folders")
          .folder
            b-btn(v-b-toggle="'folder-'+folder.id") +
            .folder-name {{folder.name}}
            .folder-actions
              font-awesome-icon(:icon="['far', 'edit']" @click="openEditModal(folder)")
              b-form-checkbox(v-model="folder.isActive" @change="setFolderActive($event, folder.id)" switch)
          b-collapse.subfolder-continer(:id="'folder-'+folder.id" visible)
            .subfolder(v-for="subfolder in folder.subfolders")
              .subfolder-name {{subfolder.name}}
              .folder-actions
                font-awesome-icon(:icon="['far', 'edit']" @click="openEditModal(subfolder)")
                b-form-checkbox(v-model="subfolder.isActive" @change="setFolderActive($event, subfolder.id)" switch)
            b-btn.btn-add-subfolder(@click="openCreateSubfolder(folder.id)" size="sm" variant="secondary") + Añadir Subcarpeta
    //- Modals
    b-modal#create-folder-modal(title="Nueva Carpeta" ref="create-folder-modal" hide-footer)
      create-edit-form(
        :serviceId="service.id"
        @done="hideModal('create-folder-modal')"
        @cancel="$refs['create-folder-modal'].hide()"
      )
    b-modal#create-subfolder-modal(title="Nueva Carpeta" ref="create-subfolder-modal" hide-footer)
      create-edit-form(
        :parentFolderId="parentFolderId"
        :serviceId="service.id"
        @done="hideModal('create-subfolder-modal')"
        @cancel="$refs['create-subfolder-modal'].hide()"
      )
    b-modal#edit-folder-modal(title="Editar Carpeta" ref="edit-folder-modal" hide-footer)
      create-edit-form(
        :folder="selectedFolder"
        :serviceId="service.id"
        edit-mode
        @done="hideModal('edit-folder-modal')"
        @cancel="$refs['edit-folder-modal'].hide()"
      )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreateEditForm from './CreateEditForm'

export default {
  components: {
    CreateEditForm
  },
  data () {
    return {
      parentFolderId: null,
      selectedFolder: null,
      collapseController: {}
    }
  },
  methods: {
    ...mapActions(['updateServiceFolder', 'getService']),
    openCreateSubfolder (parentFolderId) {
      this.parentFolderId = parentFolderId
      this.$refs['create-subfolder-modal'].show()
    },
    async setFolderActive (isActive, folderId) {
      const data = { isActive, id: folderId }
      await this.updateServiceFolder({ data, serviceId: this.service.id })
      await this.getService(this.service.id)
    },
    async hideModal (modalRef) {
      this.$refs[modalRef].hide()
      await this.getService(this.service.id)
    },
    openEditModal (folder) {
      this.selectedFolder = folder
      this.$refs['edit-folder-modal'].show()
    }
  },
  computed: {
    ...mapGetters(['service']),
    folders () {
      return [...this.service.folders]
    }
  }
}
</script>

<style lang="scss" scoped>
.folder {
  display: flex;
  .btn {
    margin-right: 1rem;
    width: 25px;
    height: 25px;
    padding: 0;
  }
  .folder-name {
    font-size: 18px;
    min-width: 120px;
    font-weight: 600;
  }
}
.subfolder-continer {
  margin-left: 12px;
  margin-top: 18px;
  padding: 0 18px;
  border-left: 1px dotted #707070;
  .subfolder {
    display: flex;
    margin-bottom: 14px;
    &-name {
      padding: 8px 10px;
      border-radius: 5px;
      background-color: #F1F5F8;
      width: 480px;
    }
  }
  .btn-add-subfolder {
    width: 180px;
  }
}
.folder-item {
 margin-bottom: 0.75rem;
}
.folder-item:last-child {
 margin-bottom: 0;
}

.folder-actions {
  display: flex;
  align-items: center;
  margin-left: 8px;
  svg {
    font-size: 19px;
    color: #7F828F;
    cursor: pointer;
    margin-right: 6px;
  }
}
</style>
